import { render, staticRenderFns } from "./infoArea02.vue?vue&type=template&id=e12bba2a"
import script from "./infoArea02.vue?vue&type=script&lang=js"
export * from "./infoArea02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports